import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import TopBar from '../../components/TopBar'
import { useAnalytics } from '../../context/AnalyticsContext'
import { useAuth } from '../../context/AuthContext'
import { supabase } from '../../lib/supabase'
import { getOnboarding } from './onboardingStorage'
import './onboarding.css'

const OnboardingPasswordExisting = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { trackEvent } = useAnalytics()
  const { signIn, resetPassword } = useAuth()
  const saved = getOnboarding()

  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)

  const onBack = () => navigate('/onboarding/email')

  const onContinue = async () => {
    if (!password || password.trim().length < 6) {
      setError(t('loginPassword.passwordMinLength'))
      return
    }
    if (password.length > 50) {
      setError(t('onboardingPassword.passwordMaxLength'))
      return
    }
    if (/\s/.test(password)) {
      setError(t('changePassword.passwordNoSpaces'))
      return
    }
    if (!saved.email) {
      setError(t('loginPassword.emailRequired'))
      return
    }

    setError('')
    setLoading(true)

    try {
      console.log('[OnboardingPasswordExisting] Attempting signIn for:', saved.email)
      const { user, error: signInError } = await signIn(saved.email, password)
      console.log('[OnboardingPasswordExisting] signIn result:', { hasUser: !!user, error: signInError })

      if (signInError) {
        // Показываем понятное сообщение об ошибке
        const errorLower = signInError.toLowerCase()
        let message = t('loginPassword.incorrectPassword')
        if (errorLower.includes('invalid') || errorLower.includes('incorrect') || errorLower.includes('wrong')) {
          message = t('loginPassword.incorrectPassword')
        } else if (errorLower.includes('timeout') || errorLower.includes('timed out')) {
          message = t('loginPassword.requestTimeout')
        } else if (errorLower.includes('email not confirmed')) {
          message = t('loginPassword.confirmEmailFirst')
        } else {
          message = signInError
        }
        
        console.log('[OnboardingPasswordExisting] Showing error:', message)
        setError(message)
        setLoading(false)
        return
      }

      if (!user) {
        console.warn('[OnboardingPasswordExisting] No user returned')
        setError(t('loginPassword.userNotFound'))
        setLoading(false)
        return
      }

      // Успешный вход
      console.log('[OnboardingPasswordExisting] ✅ Sign in successful, user ID:', user.id)
      trackEvent('funnel_password_existing_completed', { step: 10 })
      setLoading(false)

      // Переходим в App - профиль загрузится автоматически через AuthContext
      console.log('[OnboardingPasswordExisting] Navigating to /app...')
      window.location.href = '/app'
    } catch (err) {
      console.error('[OnboardingPasswordExisting] Exception:', err)
      const message = err?.message || t('loginPassword.errorSigningIn')
      setError(message)
      setLoading(false)
    }
  }

  const onForgot = async () => {
    if (!saved.email) {
      setError(t('loginPassword.emailRequired'))
      return
    }

    trackEvent('forgot_password_clicked')
    setLoading(true)

    try {
      const { error: resetError } = await resetPassword(saved.email)
      
      if (resetError) {
        setError(resetError || t('onboarding.forgotPasswordError'))
        setLoading(false)
        return
      }

      setSent(true)
    } catch (err) {
      console.error('Reset password error:', err)
      setError(t('onboarding.forgotPasswordError'))
      setLoading(false)
    }
  }

  if (sent) {
    return (
      <div className="onboarding-page">
        <TopBar currentStep={10} totalSteps={10} onBack={() => setSent(false)} showBack={true} />
        <div className="onboarding-content">
          <h1 className="h1">{t('loginPassword.checkEmail')}</h1>
          <p className="p">
            {t('onboarding.forgotPasswordSent', { email: saved.email || 'your email' })}
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="onboarding-page">
      <TopBar currentStep={10} totalSteps={10} onBack={onBack} showBack={true} />
      <div className="onboarding-content">
        <h1 className="h1">{t('loginPassword.enterPassword')}</h1>
        <p className="p">
          {t('loginPassword.subtitle')}
        </p>

        <div className="field">
          <label className="label">{t('loginPassword.passwordLabel')}</label>
          <input
            className={`input ${error ? 'error' : ''}`}
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value)
              if (error) setError('')
            }}
            placeholder="••••••••"
          />
          {error ? <div className="error-text">{error}</div> : null}
        </div>

        <button className="link" type="button" onClick={onForgot} style={{ marginTop: 10 }}>
          {t('loginPassword.forgotPassword')}
        </button>
      </div>

      <button className="cta-fixed" onClick={onContinue} disabled={loading}>
        {loading ? t('loginPassword.signingIn') : t('common.continue')}
      </button>
    </div>
  )
}

export default OnboardingPasswordExisting

